/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * Corca Yjs Service
 * OpenAPI spec version: 0.0.0
 */
import type {
  DocumentUpdateRequest,
  DocumentUpdateResponse,
  RevertResponse,
  SnapshotShowResponse,
  SnapshotsListResponse,
} from "./yjs-api.generated.schemas";

import { client } from "./client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * List document snapshots
 */
export const snapshotsList = (
  documentUid: string,
  options?: SecondParameter<typeof client<SnapshotsListResponse>>,
) => {
  return client<SnapshotsListResponse>(
    { url: `/yjs/snapshots/${documentUid}`, method: "GET" },
    options,
  );
};

/**
 * Get the document state at a specific snapshot
 */
export const snapshotsShow = (
  documentUid: string,
  snapshotId: number,
  options?: SecondParameter<typeof client<SnapshotShowResponse>>,
) => {
  return client<SnapshotShowResponse>(
    { url: `/yjs/snapshots/${documentUid}/${snapshotId}`, method: "GET" },
    options,
  );
};

/**
 * Revert document to a specific snapshot
 */
export const snapshotsRevert = (
  documentUid: string,
  snapshotId: number,
  options?: SecondParameter<typeof client<RevertResponse>>,
) => {
  return client<RevertResponse>(
    { url: `/yjs/snapshots/${documentUid}/${snapshotId}/revert`, method: "POST" },
    options,
  );
};

/**
 * Apply a Y.js update to a document
 */
export const documentsUpdate = (
  documentUid: string,
  documentUpdateRequest: DocumentUpdateRequest,
  options?: SecondParameter<typeof client<DocumentUpdateResponse>>,
) => {
  return client<DocumentUpdateResponse>(
    {
      url: `/yjs/documents/${documentUid}/update`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: documentUpdateRequest,
    },
    options,
  );
};

export type SnapshotsListResult = NonNullable<Awaited<ReturnType<typeof snapshotsList>>>;
export type SnapshotsShowResult = NonNullable<Awaited<ReturnType<typeof snapshotsShow>>>;
export type SnapshotsRevertResult = NonNullable<Awaited<ReturnType<typeof snapshotsRevert>>>;
export type DocumentsUpdateResult = NonNullable<Awaited<ReturnType<typeof documentsUpdate>>>;
